/* SFD header — brings the mockup's header and utility bar into the theme.
 *
 * Deliberately rearranges the theme's EXISTING elements rather than editing
 * sections/header.liquid (3,070 lines) or sections/topbar.liquid. Everything
 * here is reversible by removing this file and its loader line.
 *
 * Two rules that cost time to learn:
 *   1. `.header__buttons` is used by BOTH the desktop icon row and the mobile
 *      hamburger wrapper. Every selector must be scoped to
 *      .header__icons--right or the hamburger moves with it.
 *   2. The Quote control is a <button> with an inline onclick, not an anchor,
 *      and it shares its class list with the basket. It is only identifiable
 *      by the [data-quote-count] span inside it. Never rebuild it — wrap it,
 *      or the drawer stops opening.
 */
(function () {
  'use strict';

  var TEL = 'tel:+441163184182';
  var TEL_LABEL = '0116 318 4182';

  var LINKS = {
    delivery: '/pages/delivery-information',
    sectors: '/pages/sectors',
    finance: '/pages/finance-options'
  };

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------------------------------------------------------------------
     UTILITY BAR
     Left:  phone + hours, WhatsApp, delivery, sectors
     Right: VAT switch, trade account
     The WhatsApp anchor is MOVED, never recreated — it carries the working
     wa.me href and the theme's own inline icon, and wa.me is what actually
     opens the app on a phone rather than the web client.

     Sectors sits here rather than on the main bar: it is a way in for a
     buyer who knows their world but not our departments, which is a
     navigation aid, not a department of its own. It took the slot the price
     match promise had (Lee's call, 5 Oct 2026). The price promise page is
     still live and still linked from the footer and the homepage.
  --------------------------------------------------------------------- */
  function topbar() {
    var left = document.querySelector('.topbar__left');
    var right = document.querySelector('.topbar__right');
    if (!left || !right) return;

    var leftUl = left.querySelector('.topbar__menu') || left.appendChild(el('ul', 'topbar__menu sfd-util'));
    var rightUl = right.querySelector('.topbar__menu') || right.appendChild(el('ul', 'topbar__menu sfd-util'));
    leftUl.classList.add('sfd-util');
    rightUl.classList.add('sfd-util');

    if (document.querySelector('[data-sfd-util]')) return;
    leftUl.setAttribute('data-sfd-util', '');

    /* rescue the WhatsApp item before clearing */
    var wa = document.querySelector('.topbar__menu-item > a[href^="https://wa.me/"]');
    var waItem = wa && wa.closest('.topbar__menu-item');
    if (waItem) waItem.parentElement.removeChild(waItem);

    leftUl.innerHTML = '';
    rightUl.innerHTML = '';

    function item(ul, href, html, extraCls) {
      var li = el('li', 'topbar__menu-item' + (extraCls ? ' ' + extraCls : ''));
      var a = el('a', 'block reversed-link', html);
      a.setAttribute('href', href);
      a.setAttribute('rel', 'nofollow');
      li.appendChild(a);
      ul.appendChild(li);
      return li;
    }

    item(leftUl, TEL, '<strong>' + TEL_LABEL + '</strong><span class="sfd-util__soft">Mon to Fri</span>', 'sfd-util__phone');
    if (waItem) leftUl.appendChild(waItem);
    item(leftUl, LINKS.delivery, 'Delivery &amp; lead times', 'sfd-util__wide');
    item(leftUl, LINKS.sectors, 'Sectors', 'sfd-util__wide');

    /* the VAT switch belongs up here, not in the icon row: it governs every
       price on the page, so it reads as a site-wide setting rather than an
       action sitting beside the basket */
    var vatHost = el('li', 'topbar__menu-item sfd-util__vat');
    vatHost.appendChild(el('span', 'sfd-util__soft sfd-vat-caption', 'Showing prices'));
    vatHost.setAttribute('data-sfd-vat-host', '');
    rightUl.appendChild(vatHost);

    item(rightUl, LINKS.finance, '<strong>Trade account &amp; 30 day terms &rarr;</strong>', 'sfd-util__trade');

    moveVat();
  }

  /* sfd-vat.js mounts the switch into the header icon row. Both scripts are
     deferred and this one loads second, so by the time it runs the pill
     exists and can simply be relocated. Called again on section reload. */
  function moveVat() {
    var host = document.querySelector('[data-sfd-vat-host]');
    var pill = document.querySelector('.sfd-vat');
    if (host && pill && pill.parentElement !== host) host.appendChild(pill);
  }

  /* ---------------------------------------------------------------------
     HEADER ACTIONS
     Icon on the left, two lines of text on the right: a quiet label over the
     thing that changes. Same shape for all four so the row reads as one unit.
  --------------------------------------------------------------------- */
  function twoLine(node, t1, t2) {
    if (!node) return null;
    var label = node.querySelector('.header-icon-label');
    var stack = node.querySelector('.sfd-hact__text');
    if (!stack) {
      stack = el('span', 'sfd-hact__text',
        '<span class="sfd-hact__t1"></span><span class="sfd-hact__t2"></span>');
      if (label) label.parentElement.replaceChild(stack, label);
      else node.appendChild(stack);
    }
    stack.querySelector('.sfd-hact__t1').textContent = t1;
    if (t2 != null) stack.querySelector('.sfd-hact__t2').textContent = t2;
    node.classList.add('sfd-hact');
    return stack;
  }

  function headerActions() {
    var row = document.querySelector('.header__icons--right .header__buttons');
    if (!row) return;
    row.classList.add('sfd-hacts');

    /* Talk to an expert — first, because it is the one action that costs the
       customer nothing and saves the wrong order being placed. */
    if (!row.querySelector('[data-sfd-advice]')) {
      var advice = el('a', 'sfd-hact sfd-hact--advice',
        '<svg class="sfd-hact__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/>' +
        '<path d="M4 14h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/>' +
        '<path d="M20 14h-2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1z"/>' +
        '<path d="M20 19v1a2 2 0 0 1-2 2h-4"/></svg>' +
        '<span class="sfd-hact__text"><span class="sfd-hact__t1">Need some advice?</span>' +
        '<span class="sfd-hact__t2">Talk to an expert</span></span>');
      advice.setAttribute('href', TEL);
      advice.setAttribute('data-sfd-advice', '');
      advice.setAttribute('aria-label', 'Call ' + TEL_LABEL + ' to talk to an expert');
      row.insertBefore(advice, row.firstChild);
    }

    var account = row.querySelector('.account-button');
    if (account) {
      var out = /\/account\/login/.test(account.getAttribute('href') || '');
      twoLine(account, 'Trade & account', out ? 'Sign in' : 'My account');
      account.classList.remove('reversed-link--icon-only');
    }

    var quoteBtn = row.querySelector('[data-quote-count]');
    quoteBtn = quoteBtn && quoteBtn.closest('button');
    if (quoteBtn) {
      twoLine(quoteBtn, 'Quote list', quoteLabel());
      quoteBtn.classList.add('sfd-hact--quote');
    }

    var cart = row.querySelector('a[href$="/cart"], .cart-drawer-button[href]');
    if (cart) {
      twoLine(cart, 'Basket', cartLabel());
      cart.classList.add('sfd-hact--cart');
      paintCart(cart);
    }
  }

  function quoteLabel() {
    var c = document.querySelector('[data-quote-count]');
    var n = parseInt((c && c.textContent || '').replace(/\D/g, ''), 10);
    if (!n) return 'Empty';
    return n + (n === 1 ? ' item' : ' items');
  }

  function cartLabel() {
    var c = document.querySelector('cart-count');
    var n = parseInt((c && c.textContent || '').replace(/\D/g, ''), 10) || 0;
    return n ? n + (n === 1 ? ' item' : ' items') : 'Empty';
  }

  /* The basket total is not in the markup anywhere, so it has to come from
     /cart.js. One request, and only to put a number on screen — if it fails
     the item count already rendered stays as the label. */
  function paintCart(cart) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var t = cart.querySelector('.sfd-hact__t2');
        if (!t) return;
        var money = '£' + (c.total_price / 100).toFixed(2);
        t.textContent = c.item_count ? money : 'Empty';
      })
      .catch(function () {});
  }

  /* counts are rewritten by the theme and by the quote app, so mirror them */
  function watchCounts() {
    var targets = [].slice.call(document.querySelectorAll('cart-count, [data-quote-count]'));
    if (!targets.length || !window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      var row = document.querySelector('.header__icons--right .header__buttons');
      if (!row) return;
      var q = row.querySelector('.sfd-hact--quote .sfd-hact__t2');
      if (q) q.textContent = quoteLabel();
      var cart = row.querySelector('.sfd-hact--cart');
      if (cart) paintCart(cart);
    });
    targets.forEach(function (t) {
      mo.observe(t, { childList: true, characterData: true, subtree: true, attributes: true });
    });
  }

  /* ---------------------------------------------------------------------
     MOBILE SEARCH
     Below 1024px the field collapses to a magnifier and drops down as a
     full-width row when tapped. The theme's own submit button is reused as
     the trigger, so there is no second control to keep in sync — but that
     means the first tap has to be intercepted, or it submits an empty search
     instead of opening the field.
  --------------------------------------------------------------------- */
  function mobileSearch() {
    if (document.documentElement.hasAttribute('data-sfd-search-bound')) return;
    document.documentElement.setAttribute('data-sfd-search-bound', '');

    function small() { return window.matchMedia('(max-width: 1023px)').matches; }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var trigger = e.target.closest('.header__search .search__icon-search');
      if (trigger && small()) {
        var input = document.querySelector('.header__search .search__input');
        var open = document.documentElement.classList.contains('sfd-search-open');

        /* Open with something typed: run the search. Relying on the button's
           native submit was not enough, because the click is intercepted in
           the capture phase before the form ever sees it. */
        if (open && input && input.value.trim()) {
          e.preventDefault();
          e.stopPropagation();
          var form = input.closest('form');
          if (form) {
            if (form.requestSubmit) form.requestSubmit();
            else form.submit();
          }
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        document.documentElement.classList.toggle('sfd-search-open');
        if (!open && input) setTimeout(function () { input.focus(); }, 30);
        return;
      }

      /* tapping away closes it, so it never sits open over the page */
      if (document.documentElement.classList.contains('sfd-search-open') &&
          !e.target.closest('.header__search')) {
        document.documentElement.classList.remove('sfd-search-open');
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.documentElement.classList.remove('sfd-search-open');
    });

    window.addEventListener('resize', function () {
      if (!small()) document.documentElement.classList.remove('sfd-search-open');
    });
  }

  /* The category dropdown goes: on a 15,000-line catalogue nobody knows which
     of our department names their product sits under, and picking the wrong
     one returns nothing. Full-catalogue search finds it either way. */
  function search() {
    var types = document.querySelector('.search__types');
    if (types) types.setAttribute('data-sfd-hidden', '');
  }

  function run() {
    try { topbar(); } catch (e) {}
    try { headerActions(); } catch (e) {}
    try { search(); } catch (e) {}
    try { mobileSearch(); } catch (e) {}
    try { watchCounts(); } catch (e) {}
    document.documentElement.classList.add('sfd-header-on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function () { run(); moveVat(); });
  document.addEventListener('sfd:vat', moveVat);
})();
